import { Outlet } from 'react-router-dom';

import FormWithProvider from 'components/forms/form/Form';
import CustomTemplatesTabHeader from './header/CustomTemplatesTabHeader';
import CustomTemplatesTable from './table/CustomTemplatesTable';

const CustomTemplatesTab = () => {
  return (
    <FormWithProvider onSubmit={() => {}}>
      <CustomTemplatesTabHeader />
      <CustomTemplatesTable />
      <Outlet />
    </FormWithProvider>
  );
};

export default CustomTemplatesTab;
